import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'src/services';
import { useAppSelector, useAppDispatch } from 'src/store';
import { getIntegrationCatalog } from 'src/components/Integrations/IntegrationTypes';
import { CurrentIntegrations } from './CurrentIntegrations';
import { setSelectedIntegration } from 'src/store/slices/integrationSlice';

export const CurrentIntegrationField = () => {
  const [integrations, setIntegrations] = useState([]);
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const [searchParams] = useSearchParams();
  const searchProjectType = searchParams.get('type');
  const { projectType } = useAppSelector((s) => s.projectsSlices);
  const type = projectType || searchProjectType;
  const { data: currentProject, isFetching: isFetchingProject } = useGetProjectByIdQuery({
    id: id,
  });
  const integrationTypes = getIntegrationCatalog(type);

  useEffect(() => {
    if (currentProject?.integrations) {
      setIntegrations(currentProject?.integrations);

      if (currentProject?.integrations[0]) {
        dispatch(
          setSelectedIntegration({ ...selectedIntegration, ...currentProject?.integrations[0] }),
        );
      }
    }
  }, [currentProject]);

  return (
    <div className="w-full pb-2.5 border-b border-b-light">
      <div>
        <CurrentIntegrations
          isFetchingProject={isFetchingProject}
          isEmpty={!integrations.length}
          integrations={integrations}
          integrationTypes={integrationTypes}
        />
      </div>
    </div>
  );
};
